// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-with-label{font-size:14px}@media (max-width: 600px){.switch-with-label__help-icon{font-size:22px}}@media (max-width: 600px){.switch-with-label__switch.mobile-collapse{display:block;margin:auto}}\n", ""]);
// Exports
module.exports = exports;
